import { useCallback } from 'react';
import { useHistory } from 'react-router';

import useErrorHandledMutation, {
  throwOnlyUnhandledErrors,
} from 'common/hooks/useErrorHandledMutation';
import useToast from 'components/ToastProvider/useToast';

import locales from '../locales';
import { UpdateCreditCardDeactivateAtDocument } from './updateCreditCardDeactivationDate.gql';

const useUpdateCreditCardDeactivationDate = () => {
  const [mutator, { error, loading }] = useErrorHandledMutation(
    UpdateCreditCardDeactivateAtDocument,
  );

  const { showToast } = useToast();
  const history = useHistory();

  const updateCardDeactivationDate = useCallback(
    (creditCardId: string, deactivateAt?: string | null) => {
      return mutator({
        variables: {
          input: {
            creditCardId,
            deactivateAt,
          },
        },
      })
        .then(() => {
          showToast({
            message: deactivateAt
              ? locales.updateSuccess
              : locales.removeSuccess,
            type: 'success',
          });
          history.push(`/cards/${creditCardId}`);
        })
        .catch(throwOnlyUnhandledErrors);
    },
    [history, mutator, showToast],
  );

  return { error, loading, updateCardDeactivationDate };
};

export default useUpdateCreditCardDeactivationDate;
